import { render, staticRenderFns } from "./DialogEduInfo.vue?vue&type=template&id=2257d97a&scoped=true"
import script from "./DialogEduInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogEduInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogEduInfo.vue?vue&type=style&index=0&id=2257d97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257d97a",
  null
  
)

export default component.exports